import React from "react";

import { TorScheduleRow } from "../Commercial/add-plan/api";
import { ViewTORSchedule } from "../schedule/ViewTORSchedule";
import { useTorGrid } from "../Commercial/add-plan/useTorGridData";

interface PreviewTorScheduleProps {
  torScheduleData?: TorScheduleRow[];
  loading?: boolean;
}

/**
 * @author
 * @function @
 **/

export const PreviewTorSchedule = ({ torScheduleData }: PreviewTorScheduleProps) => {
  const { columnDefs, pinnedBottomRowData } = useTorGrid({ torScheduleData });
  return (
    <div>
      <ViewTORSchedule grandTotalPinnedRow={pinnedBottomRowData} columns={columnDefs} rows={torScheduleData} />
    </div>
  );
};
